var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{style:(_vm.styles)},[_vm._v(_vm._s(_vm.summary)+"  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }